import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";

import { BANNER_CACHE_KEYS } from "./keys";

import { BannerRepository } from "@/repositories/banner";
import { CreateBanner } from "@/types";

export const useCreateBanner = () => {
  const queryClient = useQueryClient();
  const bannerRepository = useRef(new BannerRepository());

  return useMutation({
    mutationFn: (data: CreateBanner) => bannerRepository.current.add(data),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: BANNER_CACHE_KEYS.LIST }),
  });
};
